import styled from "styled-components"

export const List = styled.ul`
  list-style-type: disc;
  padding-left: 2rem;
  li  {
    margin-bottom: 1.6rem;
  }
`



// WEBPACK FOOTER //
// ./src/pages/Account/Routes/Subpages/DeleteAccount/Content/styled.js